module.exports = __webpack_public_path__ + "static/media/hips.3d29ccd5.svg";